module.exports = __webpack_public_path__ + "img/titzt.ab15d6a8.png";